module.exports = __webpack_public_path__ + "img/rightside_300.94639a0a.png";